"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50643],{

/***/ 289924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);



const CustomLink = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].a(({ theme, disabled }) => `
  color: ${disabled ? theme.colors.textSecondary : theme.colors.link500};
  text-decoration: none;
  &:hover {
    color: ${theme.colors.link700};
  }
  ${disabled ? "pointer-events: none;" : ""}
`);
const BreadcrumbItem = ({
  name,
  link,
  disabled = false,
  isEndOfBread = false
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLink, {
    href: link,
    disabled,
    className: "breadcrumb-item"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    color: isEndOfBread ? "#000" : void 0,
    line: 1,
    level: 1
  }, name));
};
const Label = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 17px;
`;




/***/ }),

/***/ 955006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(289924);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203494);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ isMobile, theme }) => `
  display: flex;
  padding: ${theme == null ? void 0 : theme.spacing.s16} 0;
  align-items: ${!isMobile ? "flex-end" : "center"};
  column-gap: ${theme == null ? void 0 : theme.spacing.s4};
  white-space: nowrap;
  overflow: hidden;
  ${!isMobile ? `.breadcrumb-item:last-child div {
            white-space: normal
        }` : `
        overflow-x: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      `}
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`);
const Breadcrumbs = (_a) => {
  var _b = _a, {
    breadcrumbs = [],
    isMobile
  } = _b, rest = __objRest(_b, [
    "breadcrumbs",
    "isMobile"
  ]);
  if (!breadcrumbs.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    isMobile
  }), breadcrumbs.map((item, index) => {
    const isLast = index === breadcrumbs.length - 1 || item.isLast;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      key: index
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbItem */ .g, __spreadValues({
      key: index
    }, item)), !isLast && !!item.name && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RightOutlined */ .g, {
      color: "placeholder",
      size: 16,
      style: { textAlign: "right", overflow: "visible" }
    }));
  }));
};




/***/ }),

/***/ 517293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ChevronForwardFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChevronForwardFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      { tag: "title", attr: {}, child: [] },
      {
        tag: "polyline",
        attr: {
          points: "184 112 328 256 184 400",
          strokeWidth: "48px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "currentColor"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 848884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HomepageFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomepageFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.512 1.43055C11.7928 1.18982 12.2073 1.18982 12.4881 1.43055L21.4881 9.14455C21.7264 9.3488 21.8123 9.67984 21.7035 9.9742C21.5946 10.2686 21.3139 10.464 21 10.464H20.75V19.18C20.75 20.1852 19.9665 21 19 21H15V16.1776C15 15.6001 14.7542 15.0462 14.3166 14.6378C13.879 14.2294 13.2856 14 12.6667 14H11.3333C10.7144 14 10.121 14.2294 9.6834 14.6378C9.24583 15.0462 9 15.6001 9 16.1776V21H5C4.0335 21 3.25 20.1852 3.25 19.18V10.464H3.00004C2.68618 10.464 2.40551 10.2686 2.29662 9.9742C2.18773 9.67984 2.27365 9.3488 2.51195 9.14455L11.512 1.43055Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 124902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(203494);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29921);






const Description = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ content, maxHeight, showLessLabel, showMoreLabel, className }, ref) => {
  const contentWrapper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const htmlRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
  const expandContent = (showMore) => {
    var _a, _b;
    const contentElement = htmlRef.current;
    setExpanded(showMore);
    if (showMore) {
      (_a = contentWrapper.current) == null ? void 0 : _a.style.setProperty("max-height", (contentElement == null ? void 0 : contentElement.offsetHeight) + "px");
    } else {
      (_b = contentWrapper.current) == null ? void 0 : _b.style.setProperty("max-height", maxHeight + "px");
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const contentElement = htmlRef.current;
    if (contentElement) {
      const { offsetHeight } = contentElement;
      if (offsetHeight > maxHeight) {
        expandContent(false);
      }
    }
  }, [htmlRef]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    ref,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ContentWrapper, {
    ref: contentWrapper,
    maxHeight
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(HtmlRenderer, {
    ref: htmlRef,
    dangerouslySetInnerHTML: { __html: content }
  }))), expanded !== void 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ShowMoreButton, {
    block: true,
    size: "s",
    suffix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .RightOutlined */ .g, {
      className: "suffix",
      "aria-expanded": expanded
    }),
    onClick: () => expandContent(!expanded)
  }, expanded ? showLessLabel : showMoreLabel));
});
const ContentWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  overflow: hidden;
  max-height: ${(props) => props.maxHeight}px;
  transition: max-height 0.5s ease-in-out;
`;
const HtmlRenderer = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  max-width: 100%;
  img {
    max-width: 100%;
  }
`;
const ShowMoreButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)`
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.divider};
  border-radius: 0;
  color: ${(props) => props.theme.colors.link500};
  padding: 0.625rem;
  height: unset;

  .button-text {
    font-weight: 400;
  }
  :hover {
    border-top: 1px solid ${(props) => props.theme.colors.divider};
    color: ${(props) => props.theme.colors.link600};
  }
  .suffix {
    /* transition: transform 0.5s ease-in-out; */
    &[aria-expanded='true'] {
      transform: rotate(-90deg);
    }
  }
`;
Description.displayName = "Description";
Description.defaultProps = {
  showMoreLabel: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Xem th\xEAm"),
  showLessLabel: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Thu g\u1ECDn"),
  maxHeight: 500
};




/***/ }),

/***/ 192719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ RelateVideosAndPosts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(517293);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  line-height: 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 540px;\n  background-color: black;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const YoutubeFrame = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 42609).then(__webpack_require__.bind(__webpack_require__, 742609)).then((mod)=>mod.YoutubeFrame), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(742609)
            ]
    }
});
const MAX_ITEMS_WITH_TWO_BLOCKS = 3;
const StyledH3 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].h3(_templateObject());
const IFramePopupWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject1());
const StyledCustomLink = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x)(_templateObject2());
const RelatedBlock = (props)=>{
    const { 0: youtubeLink , 1: setYoutubeLink  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const { title , type , seeMoreUrl , items  } = props;
    const renderItem = (url, description)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
            gap: "s8",
            align: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .LazyImage */ .w, {
                    height: "56px",
                    width: "100px",
                    borderRadius: 6,
                    contain: true,
                    src: url,
                    imageWidth: 200
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                    width: "calc(100% - 100px - 16px)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                        line: 3,
                        level: 1,
                        children: description
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                padding: "s16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledH3, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                        gap: "s12",
                        direction: "column",
                        marginTop: "s12",
                        children: items.map((item, index)=>{
                            const { url , thumbnailUrl , description  } = item;
                            return type === "post" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCustomLink, {
                                href: url,
                                target: "_blank",
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                                onClick: ()=>setYoutubeLink(url),
                                style: {
                                    cursor: "pointer",
                                    width: "100%"
                                },
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url));
                        })
                    }),
                    !!seeMoreUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
                        href: seeMoreUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                            paddingTop: "s16",
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                                variant: "link",
                                children: [
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Xem th\xeam nội dung"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .ChevronForwardFilled */ .O, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Modal */ .u, {
                visible: !!youtubeLink,
                width: "960px",
                onClose: ()=>setYoutubeLink(""),
                showCloseIcon: false,
                footer: false,
                contentStyle: {
                    padding: "0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IFramePopupWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeFrame, {
                        youtubeLink: youtubeLink
                    })
                })
            })
        ]
    });
};
const RelateVideosAndPosts = (props)=>{
    var ref, ref1, ref2, ref3;
    const { relatedPosts , relatedVideos  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref = relatedVideos.urls) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: relatedVideos.urls.map((video, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "VideoObject",
                                name: video.name,
                                description: video.description,
                                thumbnailUrl: video.thumbnailUrl,
                                uploadDate: typeof video.uploadDate === "number" ? new Date(video.uploadDate * 1000).toISOString() : "",
                                embedUrl: video.url
                            })
                        }
                    }, "".concat(index).concat(video.url));
                })
            }),
            !!(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref1 = relatedPosts.urls) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                marginTop: "s12",
                marginBottom: !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref2 = relatedVideos.urls) === null || ref2 === void 0 ? void 0 : ref2.length) ? "s0" : "s12",
                backgroundColor: "white",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedPosts.title || "",
                    type: "post",
                    seeMoreUrl: relatedPosts.seeMoreUrl,
                    items: relatedPosts.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , description  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: description || ""
                        };
                    })
                })
            }),
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref3 = relatedVideos.urls) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                margin: [
                    "s12",
                    "s0"
                ],
                backgroundColor: "white",
                border: "s8",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedVideos.title || "",
                    type: "video",
                    seeMoreUrl: relatedVideos.seeMoreUrl,
                    items: relatedVideos.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , name  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: name || ""
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 550643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(955006);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(848884);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(124902);
/* harmony import */ var components_HeadSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(665207);
/* harmony import */ var components_RelatedVideosAndPosts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(192719);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ProductListWithFilter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(814342);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: white;\n  margin-bottom: 1rem;\n  border-radius: 1rem;\n  line-height: 1.5rem;\n  .table table {\n    max-width: 100%;\n    table-layout: auto;\n  }\n  .ck-content .table table td,\n  .ck-content .table table th {\n    min-width: 2em;\n    padding: 0.4em;\n    border: 1px solid #bfbfbf;\n  }\n  ul,\n  ul li {\n    list-style-type: inherit;\n  }\n\n  ul {\n    /* Default user agent stylesheet. */\n    padding-left: 40px;\n  }\n\n  ol,\n  ol li {\n    list-style-type: decimal;\n  }\n  ol {\n    /* Default user agent stylesheet, you can change it to your needs. */\n    padding-left: 40px;\n  }\n\n  h2 {\n    font-size: 20px;\n    line-height: 1.4;\n  }\n  h3 {\n    font-size: 16px;\n    line-height: 1.3;\n  }\n  h4 {\n    font-size: 14px;\n  }\n  h5 {\n    font-size: 12px;\n  }\n  h6 {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












const FAQSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 65458).then(__webpack_require__.bind(__webpack_require__, 565458)).then((mod)=>mod.FAQSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(565458)
            ]
    }
});
const SearchPage = (props)=>{
    var ref, ref1, ref2, ref3;
    const { breadcrumbs , seoInfo , forceNoIndex , serverProducts , serverFilters , filterPrice , serverPagination , featuredProducts , inlineBanners ,  } = props;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { query , asPath  } = router;
    const { page  } = query;
    const { epicOmni976 , addSchemaBreadcrumbList , baseDomain , epicEcom495 , isPaginalSearchPage ,  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    // display breadcrumbs for collection page
    const breadCrumbs = [
        ...!asPath.startsWith("/search") ? epicEcom495 ? [
            {
                link: "/",
                name: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .HomepageFilled */ .f, {
                            size: 16,
                            color: "placeholder",
                            style: {
                                marginRight: "4px"
                            }
                        }),
                        (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Trang chủ")
                    ]
                })
            }, 
        ] : [
            {
                name: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .HomepageFilled */ .f, {
                    size: 24,
                    color: "placeholder"
                }),
                link: "/"
            }, 
        ] : [],
        ...(epicOmni976 || epicEcom495) && breadcrumbs && breadcrumbs.length ? breadcrumbs : [],
        ...(seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.siteTitle) ? [
            {
                disabled: true,
                link: "#",
                name: seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.siteTitle,
                isEndOfBread: true
            }, 
        ] : [], 
    ];
    const isShowRelatedPostsAndVideos = !!(seoInfo === null || seoInfo === void 0 ? void 0 : (ref = seoInfo.relatedVideos) === null || ref === void 0 ? void 0 : (ref1 = ref.urls) === null || ref1 === void 0 ? void 0 : ref1.length) || !!(seoInfo === null || seoInfo === void 0 ? void 0 : (ref2 = seoInfo.relatedPosts) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.urls) === null || ref3 === void 0 ? void 0 : ref3.length);
    const isShowSiteDescription = isShowRelatedPostsAndVideos || (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.siteDescription) && !page;
    const metaTitle = (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.metaTitle) || (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.siteTitle);
    const paginationMetaTitle = isPaginalSearchPage && !!page ? "".concat(page, " - ").concat(metaTitle) : metaTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!addSchemaBreadcrumbList && !!(breadCrumbs === null || breadCrumbs === void 0 ? void 0 : breadCrumbs.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            itemListElement: breadCrumbs.map((param, index)=>{
                                let { name , link  } = param;
                                return {
                                    "@type": "ListItem",
                                    position: index + 1,
                                    item: {
                                        name: typeof name === "string" ? name : !index && (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Trang chủ"),
                                        "@id": index === breadCrumbs.length - 1 || link === "#" ? "".concat(baseDomain).concat(asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0]) : "".concat(baseDomain).concat(link)
                                    }
                                };
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HeadSection__WEBPACK_IMPORTED_MODULE_7__/* .HeadSection */ .I, _objectSpreadProps(_objectSpread({}, seoInfo), {
                noindex: forceNoIndex || !(seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.canonical),
                title: paginationMetaTitle,
                metaTitle: paginationMetaTitle,
                canonical: isPaginalSearchPage && !!page ? undefined : seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.canonical,
                links: [
                    (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.siteDescription) ? {
                        rel: "stylesheet",
                        href: "https://shopfront-cdn.tekoapis.com/static/stylesheet/ckeditor.css"
                    } : {}, 
                ],
                image: seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.thumbnailUrl
            })),
            breadCrumbs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Breadcrumbs */ .O, {
                    breadcrumbs: breadCrumbs,
                    paddingLeft: "s16"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductListWithFilter__WEBPACK_IMPORTED_MODULE_10__/* .ProductListWithFilter */ .A, {
                marginTop: breadCrumbs ? undefined : "s16",
                serverProducts: serverProducts,
                serverPagination: serverPagination,
                serverFilters: serverFilters,
                filterPrice: filterPrice,
                siteTitle: seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.siteTitle,
                serverSeoInfo: seoInfo,
                featuredProducts: featuredProducts,
                inlineBanners: inlineBanners
            }),
            !isPaginalSearchPage && !page && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (isShowRelatedPostsAndVideos || isShowSiteDescription) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k, {
                            gap: "s16",
                            align: "initial",
                            children: [
                                isShowSiteDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Shape */ .b, {
                                    width: isShowRelatedPostsAndVideos ? "calc((100% - 16px)/3 * 2)" : "100%",
                                    marginTop: "s12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDescription, {
                                        className: "ck-content",
                                        content: (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.siteDescription) || "Đang cập nhật...",
                                        maxHeight: 760,
                                        showMoreLabel: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Xem th\xeam nội dung"),
                                        showLessLabel: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Thu gọn nội dung")
                                    })
                                }),
                                isShowRelatedPostsAndVideos && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Shape */ .b, {
                                    width: "calc((100% - 16px)/3)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RelatedVideosAndPosts__WEBPACK_IMPORTED_MODULE_13__/* .RelateVideosAndPosts */ .T, {
                                        relatedVideos: seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.relatedVideos,
                                        relatedPosts: seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.relatedPosts
                                    })
                                })
                            ]
                        })
                    }),
                    !!(query === null || query === void 0 ? void 0 : query.slug) && !!(seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.faq) && seoInfo.faq.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQSection, {
                        faq: seoInfo.faq
                    }) : null
                ]
            })
        ]
    });
};
const StyledDescription = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_15__/* .Description */ .d)(_templateObject());


/***/ })

}]);